<template>
    <div class="bookDiv">
        <div class="book-container">
            <div class="binding"></div>
            <!-- 页面容器 -->
            <div ref="pagesContainer" class="pages-container">
                 <!-- 动态加载的页面将插入到这里 -->
                <div v-for="(page, index) in pages" :key="index" class="page-item" >
                    {{ page.content }}
                </div>
             </div>
            <!-- 翻页按钮和页码 -->
            <div class="navigation-buttons">
                <button class="prev-page" @click="prevPage">上一页</button>
           
                <!-- 页码显示 -->
                <div ref="pageNumber" class="page-number">
                {{ currentPage }}/{{ totalPages }}
                </div>

                <button class="next-page" @click="nextPage">下一页</button>
            </div>
        </div>
    </div>
</template>
<script>
import api from "@/request/api";
export default {
    props: ['readerData','chapMap','chapMapIndex','chapterListData'],
    // name: "readerCom",
    data() {
        return {
            content:'',
            // 分页数据
            currentPage: 1,
            totalPages: 0,
            pages: [],
            allContent:'',
            contentData:{},//展示内容
            bookTitle:'',//标题
            bookCon:"",//图片
            bookType:1,//类型
            localChapMap: JSON.parse(JSON.stringify(this.chapMap)),
            childrenId:[],//家族成员信息的children id
            childrenName:[],//家族成员信息的children id
            newIndex:0,
            infoData:[],
            newPage:1,
            pageF:0,
            is98:false,
        }
    },
    components: {
       
    },
    mounted() {
        //获取数据
        this.getReaderData()
    },
    beforeDestroy() {
        // 清理事件监听
        window.removeEventListener('resize', this.init)
    },
    computed: {
        // 显示用页码（从1开始）
        displayPage() {
            return this.currentPage + 1
        },
        toChies(val) {
            return function (val) {
                return this.$utils.toChies(val);
            };
        },
    },
    methods: {
        //获取数据
        getReaderData(){
            // console.log(this.chapterListData,'----chapterListData')
            for (const item of this.chapterListData[1]) {
                if(item.type==9){
                const { id, name } = this.collectNodeAttributes(item.children, 'id', 'name')
                 this.childrenId= id
                 this.childrenName= name
                }
            }
            this.totalPages=this.chapterListData[1].length-1+  this.childrenId.length;//总数
            // console.log(this.localChapMap,'-----localChapMap')
            api.chapterGet(this.$qs.stringify({ id:this.localChapMap.id })).then((res) => {
                if (res.code == 0) {
                    // console.log(res.data,'------ res.data')
                    this.bookType = res.data.type;
                    this.bookTitle=res.data.name
                        this.bookCon = JSON.parse(res.data.content);
                        this.contentData=JSON.parse(res.data.content)
                        // this.allContent=JSON.parse(res.data.content).content
                        let newContent=""
                        switch (this.localChapMap.type) {
                            case 1: //祖宗赞像
                            newContent +='<h1 style="margin-bottom:30px">'+ this.bookTitle +'</h1>'
                            if(this.bookCon.avator.length!=0){
                                newContent +='<ul>'
                                for(var i=0;i<this.bookCon.avator.length;i++){
                                    newContent +=`<li><img src="${this.bookCon.avator[i]}" style="max-width: 70%;max-height:70%; object-fit: contain;"/></li>`
                                }
                                newContent +='</ul>'
                            }
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'
                            break;
                            case 2: //姓氏图腾
                            newContent +='<h1 style="margin-bottom:30px">'+ this.bookTitle +'</h1>'
                            if(this.bookCon.avator.length!=0){
                                newContent +='<ul>'
                                for(var i=0;i<this.bookCon.avator.length;i++){
                                    newContent +=`<li><img src="${this.bookCon.avator[i]}" style="max-width: 70%;max-height:70%; object-fit: contain;"/></li>`
                                }
                                newContent +='</ul>'
                            }
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'

                            break;
                            case 3: //谱论题词
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(名人、先贤、家人论述家谱的重要性)</p>'
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'
                            break;  
                            case 4: //凡例
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(凡例是编修家谱所遵循的规则)</p>'
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'
                            break;  
                            case 5: //姓氏源流
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(记录本姓起源、始祖、始迁祖、世派、迁徙源流等)</p>'
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'
                            break;
                            case 6: // 家谱序言
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(主要介绍姓氏源流、迁徙经过、郡望堂号、编谱原则、编谱过程等)</p>'
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'
                            break;
                            case 7: // 家规
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(教育、规范和约束家族成员的训诫、法规)</p>'
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'
                            break;
                            case 17: // 家训
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(教育、规范和约束家族成员的训诫、法规)</p>'
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'
                            break;
                            case 8: // 字辈谱
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(又称昭穆、字派、行派、排序，即用以表明同祖为宗家族世序血缘秩序的命名字辈序列)</p>'
                            if(this.bookCon.content.length!=0){
                                newContent +='<ul>'
                                for(var i=0;i<this.bookCon.content.length;i++){
                                    newContent +='<li><p>'+this.bookCon.content[i].shixu+'世</p><p>'+this.bookCon.content[i].beifen+'</p></li>'
                                }
                                newContent +='</ul>'
                            }
                            break;
                            case 9: // (家族成员信息（世系图)
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(家族成员信息（世系图)</p>'
                            break;
                            case 10: // (家族照片)
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(家族照片)</p>'
                            break;
                            case 11: // 传记艺文
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(家族中有重要贡献的人物事迹或族人的著述)</p>'
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'
                            break;
                            case 12: // 坟茔碑文
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(记录家族墓地图、坟向、碑文内容等)</p>'
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'
                            break;
                            case 13: // 祠堂
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(记录家族祭祀和议事场所)</p>'
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'
                            break;
                           
                            case 14: // 大事记
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(何时、何地、何事、何因、何果、评价)</p>'
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'
                            break;
                            case 15: // 编委会
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(何时、何地、何事、何因、何果、评价)</p>'
                            if(this.bookCon.avator.length!=0){
                                newContent +='<ul>'
                                for(var i=0;i<this.bookCon.avator.length;i++){
                                    newContent +=`<li><img src="${this.bookCon.avator[i]}" style="max-width: 70%;max-height:70%; object-fit: contain;"/></li>`
                                }
                                newContent +='</ul>'
                            }
                            break;
                            case 16: // 大事记
                            newContent +='<h1>'+ this.bookTitle +'</h1><p>(说明家谱编修果,或请假内容对后人的嘱托)</p>'
                            newContent+='<h2>'+JSON.parse(res.data.content).content+'</h2>'
                            break;
                            
                        }

                        this.allContent=newContent
                        // console.log( this.allContent,'----- this.allContent')

                    // }else{
                    //     this.bookCon=""
                    //     this.contentData=""
                    //     this.allContent=""
                    // }
                    // console.log(this.allContent,'------ allContent')
                    
                    this.init();
                    // 添加窗口resize监听
                    window.addEventListener('resize', this.init)
                    const pageHeight =  this.getPageContentHeight() - 140;
                    this.pages = this.splitContentByHeight(this.allContent, pageHeight);
                    this.newPage=1
                    // console.log(this.pages,'----111111111111111111111lthis.pagesContent')
                }
            });
        },
        collectNodeAttributes(nodes, ...keys) {
            // 参数验证
            if (!Array.isArray(nodes)) {
                throw new TypeError('Expected an array for nodes')
            }

            const stack = [...nodes]
            const result = keys.reduce((acc, key) => {
                acc[key] = []
                return acc
            }, {})
            while (stack.length > 0) {
                const node = stack.pop()
                // 收集指定属性
                keys.forEach(key => {
                    if (node[key] !== undefined) {
                        result[key].push(node[key])
                    }
                })
                // 处理子节点（保持原始顺序）
                if (Array.isArray(node.children)) {
                    // 使用倒序压栈保持正向遍历
                    for (let i = node.children.length - 1; i >= 0; i--) {
                        stack.push(node.children[i])
                    }
                }
            }
                console.log(result,'---result')
            return result
        },
        //获取成员信息
        getInFoDataNew(id){
            api.memberGetinfo(this.$qs.stringify({ mid:id, num: 5 }))
            .then((res) => {
                if (res.code == 0) {
                    this.infoData=res.data
                    // console.log(this.infoData,'------成员信息')
                    let infoHtml1="";
                    this.infoData.forEach((item,index)=>{
                        infoHtml1 +='<h3>'+this.toChies(item.shixu)+'世</h3><h4>'+ item.name  +'</h4><h5><p>'+item.info+'</p></h5>'
                    })
                    const pageHeight =  this.getPageContentHeight() - 140;
                    this.pages = this.splitContentByHeight(infoHtml1, pageHeight);
                    this.loadPages( );
                    this.updatePageNumber();
                    this.newPage=1
                    // console.log(infoHtml1,'----inFoinfoHtml成员信息')
                }
            })
        },
         // 精确计算可用内容高度
         getPageContentHeight(){
            const tempPage = document.createElement('div');
            tempPage.className = 'page';
            tempPage.innerHTML = `<div class="content" style="visibility: hidden">测量</div>`;
            document.body.appendChild(tempPage);
            
            const contentHeight = tempPage.querySelector('.content').offsetHeight;
            document.body.removeChild(tempPage);
            
            return contentHeight;
         },
        // 增强版测量容器创建
        createMeasurer() {
            const bookContainer = document.querySelector('.book-container');
            const measurer = document.createElement('div');
            
            // 精确复制容器样式
            const styles = window.getComputedStyle(bookContainer);
            measurer.style.cssText = `
                position: absolute;
                visibility: hidden;
                width: ${bookContainer.clientWidth / 2}px;
                height: auto;
                padding: 30px;
                font-family: ${styles.fontFamily};
                font-size: ${styles.fontSize};
                line-height: ${styles.lineHeight};
                box-sizing: border-box;
            `;
            
            document.body.appendChild(measurer);
            return measurer;
        },
        // 通用元素测量方法
         measureElementHeight(element, measurer) {
            const clone = element.cloneNode(true);
            measurer.appendChild(clone);
            const height = clone.offsetHeight;
            measurer.removeChild(clone);
            return height;
        },
        // 改进的分页算法
        splitContentByHeight(content, pageHeight) {
            // console.log(content,"-------content")           // console.log(pageHeight)
            // console.log(pageHeight,"-------pageHeight")           // console.log(pageHeight)
             // 步骤1: 包裹内容到容器元素
            const wrappedContent = `<div id="content-root">${content}</div>`;
            const doc = new DOMParser().parseFromString(wrappedContent, 'text/html');
            const root = doc.getElementById('content-root');

            // 步骤2: 获取所有子节点（包含文本节点）
            const nodes = root.childNodes;
            const pages = [];
            let currentPage = [];
            let currentHeight = 0;

            // 步骤3: 创建精确测量容器
            const measurer = this.createMeasurer();

            // 步骤4: 遍历所有节点
            Array.from(nodes).forEach(node => {
                // 将文本节点转换为带样式的<span>
                let element;
                if (node.nodeType === Node.TEXT_NODE) {
                element = document.createElement('span');
                element.textContent = node.textContent;
                element.style.cssText = window.getComputedStyle(root).cssText;
                } else {
                element = node.cloneNode(true);
                }

                // 测量高度
                const height = this.measureElementHeight(element, measurer);
                
                // 分页逻辑
                if (currentHeight + height > pageHeight) {
                if (currentPage.length > 0) {
                    pages.push(currentPage.join(''));
                    currentPage = [];
                    currentHeight = 0;
                }
                }

                currentPage.push(element.outerHTML || element.textContent);
                currentHeight += height;
            });

            // 处理最后一页
            if (currentPage.length > 0) {
                pages.push(currentPage.join(''));
            }

            return pages;
        },
         // 精确测量单个段落高度（改进版）
        getParagraphHeight(paragraph) {
            const measurer = document.createElement('div');
            measurer.className = 'page';
            measurer.style.cssText = `
                position: absolute;
                visibility: hidden;
                width: ${document.querySelector('.book-container').clientWidth / 2}px;
                padding: 5%;
            `;
            
            const contentClone = document.createElement('div');
            contentClone.className = 'content';
            contentClone.style.cssText = window.getComputedStyle(document.querySelector('.content')).cssText;
            contentClone.appendChild(paragraph.cloneNode(true));
            
            measurer.appendChild(contentClone);
            document.body.appendChild(measurer);
            
            const height = contentClone.offsetHeight;
            document.body.removeChild(measurer);
            
            return height;
        },
         // 动态创建页面
         createPage(content, isLeft) {
            // console.log(content,'----content')
            // console.log(isLeft,'----isLeft')
            const page = document.createElement('div');
            page.className = `page ${isLeft ? 'page-left' : 'page-right'}`;
            page.innerHTML = `
                <div class="header">${isLeft ? '左页' : '右页'}</div>
                <div class="content">${content || '<p>（空白页）</p>'}</div>
                <div class="footer">页脚</div>
            `;
            return page;
        },
        // 其他函数保持基本结构，增加容错处理
        loadPages(page) {//
            page=this.newPage
            // console.log(page,'----page456')
            // console.log(this.pages,'----pages')
            this.$refs.pagesContainer.innerHTML = '';
            const startIndex = (page - 1) * 2;
            
            [startIndex, startIndex + 1].forEach(i => {
                if(i>=this.pages.length){
                    return
                }
                // console.log(this.pages,'----this.pages1111111111')
                // console.log(this.pages[i],'----this.pages[i]1111111')
                const content = this.pages[i] || '';
                // console.log(content,'----contentloadPages')
                this.$refs.pagesContainer.appendChild(this.createPage(content, i % 2 === 0));
            });
        },

        // 更新页码显示
        updatePageNumber() {
            // console.log(this.localChapMap,'----this.currentPage')
            this.$refs.pageNumber.textContent = `第 ${ this.pageF+1} 页`;
            // if(this.localChapMap.type==9||this.localChapMap.type==98){
            //     this.$refs.pageNumber.textContent = `第 ${this.currentPage+this.newIndex+1} 页`;
            // }else{
            //     this.$refs.pageNumber.textContent = `第 ${this.currentPage+this.newIndex} 页`;
            // }
        },
         // 翻页逻辑
         flipPage(direction) {
            if (direction === 'next' &&  this.currentPage <  this.totalPages) {
                this.currentPage += 1; // 一次翻两页
            } else if (direction === 'prev' &&  this.currentPage > 1) {
                this.currentPage -= 1; // 一次翻两页
            }
            this.loadPages( this.currentPage);
            this.updatePageNumber();
        },

        // 改进的初始化流程
        init() {
            // 动态计算书籍尺寸
            const screenRatio = window.innerWidth / window.innerHeight;
            const a4Ratio = Math.sqrt(2);
            const maxWidth = window.innerWidth * 0.95;
            const maxHeight = window.innerHeight * 0.95;
            
            const bookContainer = document.querySelector('.book-container');
            const bookWidth = Math.min(maxWidth, maxHeight * a4Ratio);
            const bookHeight = bookWidth / a4Ratio;
            
            bookContainer.style.width = bookWidth + 'px';
            bookContainer.style.height = bookHeight + 'px';
           

            // 等待渲染完成
            setTimeout(() => {
                const pageHeight =  this.getPageContentHeight() - 140;
                // console.log(this.allContent,'-----dataallContent')
                // console.log(this.currentPage,'-----currentPage')
                // console.log(this.totalPages,'-----totalPages')
                // console.log(pageHeight,'-----pageHeight')
                this.pages = this.splitContentByHeight(this.allContent, pageHeight);
                // console.log(this.pages,'----this.pages')
                // this.totalPages = Math.ceil(this.pages.length / 2);
                this.loadPages( this.currentPage);
                this.updatePageNumber();
                // console.log('计算高度:', pageHeight, '实际内容:', this.allContent.length);
            }, 100);
            
        },
        prevPage(){
            if(this.pageF>0){
                this.pageF--
            }else{
               return 
            }
            this.updatePageNumber();
console.log(this.localChapMap.id,'==============id');
            if(this.localChapMap.type==9||this.localChapMap.type==98){
                if(this.newIndex >0){
                        this.bookType=98
                        console.log(this.newIndex,'----newIndex111')
                        this.newIndex-=2;
                        console.log(this.newIndex,'----newIndex222')
                        // this.newIndex--;
                        if(this.newIndex>=0){
                            this.getInFoDataNew(this.childrenId[this.newIndex]);
                            this.bookTitle=this.childrenName[this.newIndex]
                            console.log(this.newIndex,'----newIndex222')
                            console.log(this.childrenId[this.newIndex],'---this.childrenId[this.newIndex]22222')
                            this.newIndex++
                        return 
                    }else{
                        this.newIndex=0
                    }

                }
            }
            console.log(this.currentPage,'----this.currentPage')
            if (this.currentPage > 0) {
                if (!this.is98){
                this.currentPage--;
            }else if (this.newIndex==0&&this.is98){
                this.is98=false
            }
                this.localChapMap=this.chapterListData[1][this.currentPage]
                this.getReaderData()
                this.loadPages(this.currentPage);
            }else if(this.currentPage==0){//在第一页的时候点击上一页返回封面
                this.$emit("coverFun",1);
            }
        },

        nextPage(){
            if(this.pageF < this.totalPages){
                this.pageF++
            }
            this.updatePageNumber();
            if(this.localChapMap.type==9||this.localChapMap.type==98){
                this.is98=true
                if(this.newIndex < this.childrenId.length){
                        this.bookType=98
                        console.log(this.newIndex,'---this.newIndex')
                        this.getInFoDataNew(this.childrenId[this.newIndex]);
                        this.bookTitle=this.childrenName[this.newIndex]
                        // console.log(this.childrenId,'---this.childrenId')
                        // console.log(this.childrenName,'---this.childrenName')
                        // console.log(this.bookTitle,'---this.bookTitle')
                        // console.log(this.bookType,'---this.bookType')
                       
                        this.newIndex++;
                        return 
                }
            }
            console.log(this.newIndex,'----this.newIndex')
            if (  this.currentPage <   this.totalPages-1) {
                this.currentPage++;
                this.localChapMap=this.chapterListData[1][this.currentPage]
                // console.log(this.localChapMap,'------this.localChapMap  点击的数据')
                this.getReaderData()
                this.loadPages(this.newPage);
                this.updatePageNumber();
            }
        },
        scrollToPage() {
            this.$nextTick(() => {
                const container = this.$refs.pagesContainer
                if (container) {
                    const pageWidth = container.clientWidth
                    container.scrollTo({
                        left: pageWidth * this.currentPage,
                        behavior: 'smooth'
                    })
                }
            })
        },

        // 窗口resize处理
        handleResize() {
            this.scrollToPage()
        }
     },
}
</script>
<style>
:root {
    --binding-width: 20px; /* 装订线宽度 */
    /* --page-color: #f7f2e3; */
 }
.bookDiv {
      margin: 0;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #c4b9a5;
        font-family: '华文宋体', 'SimSun', serif;
        overflow: hidden;
        position: relative;   
}

.page-item{
    /* width: 45%;
    margin-left:2%; */
}

.page-item h1{
    line-height: 50px !important;
    font-size: 26px !important;
    font-weight: bold !important;
    padding: 10px 0 !important;
    text-align: center;
   
}
.page-item ul{
    
}
.page-item ul li img{
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}
.page-item p{
    font-size:16px !important;
    letter-spacing: 0px !important;
}
.itemRight{
    margin: 70px 0 70px 6%;
}
.itemRight p span{
    font-size:16px !important;
    letter-spacing: 0px !important;
}
.itemCon{
    /* margin: 70px auto; */
    font-size: 16px !important;
    border: 1px solid #000;
    padding: 15px;
}
.itemUl{
    margin:0 auto;
}
.itemUl li{
    width: 100px;
    display: inline-block;
    border-bottom: 1px solid #fff;
    border-right: 1px solid #fff;
}
.itemUl li p{
    border: 1px solid #fff;
    border-bottom: 0;
    border-right: 0;
    text-align: center;
}

/* 书籍容器 */
.book-container {
    display: flex;
    position: relative;
    box-shadow: 
        0 0 10px rgba(0,0,0,0.3),
        0 0 0 1px rgba(0,0,0,0.1);  /* 书籍外边框 */
     border-radius: 5px;/*书籍圆角 */
     background: #e0d8c8; /*书籍背景色 */
    overflow: hidden; 
}

/* 页面容器 */
.pages-container {
   display: flex;
    width: 100%;
    height: 100%;
    position: relative;
    transition: transform 0.5s ease-in-out;
    overflow: hidden;    /* 隐藏溢出内容 */
}

/* 左右页面 */
.page {
  width: 50%;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    overflow: auto;
    border: 1px solid #d0c4b0; /*页面边框 */
}

/* 左页面 */
.page-left {
     box-shadow: 
        inset -5px 0 10px -3px rgba(0,0,0,0.2),
        5px 0 15px -5px rgba(0,0,0,0.3);
    border-right: 1px solid #d0c4b0; /* 左页面右侧边框 */
}

/* 右页面 */
.page-right {
    box-shadow: 
        inset 5px 0 10px -3px rgba(0,0,0,0.2),
        -5px 0 15px -5px rgba(0,0,0,0.3);
    border-left: 1px solid #d0c4b0;  /*右页面左侧边框 */
}

/* 装订线 */
.binding {
     position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: var(--binding-width);
    background: linear-gradient(
        to right,
        rgba(0,0,0,0.1) 0%,
        rgba(0,0,0,0.3) 50%,
        rgba(0,0,0,0.1) 100%
    );
    transform: translateX(-50%);
    z-index: 2;
    box-shadow: 
        inset 0 0 10px rgba(0,0,0,0.2),
        0 0 5px rgba(0,0,0,0.1); /*装订线阴影 */
}

/* 正文样式 */
.content {
    text-indent: 2em;
    line-height: 1.8;
    color: #5a4a32;
    text-align: justify;
    font-size: 1.05rem;
    height: calc(100% - 40px); /* 确保内容不会压住页脚 */
}

/* 页眉页脚 */
.header {
    /* position: absolute;
    top: 10px;
    width: calc(100% - 10%);
    border-bottom: 1px solid #d0c4b0;
    padding-bottom: 5px;
    font-size: 0.9em;
    color: #8b7355; */
}
.footer {
    position: absolute;
    bottom: 10px;
    width: calc(100% - 10%);
    border-top: 1px solid #d0c4b0;
    padding-top: 5px;
    font-size: 0.9em;
    color: #8b7355;
}

/* 翻页按钮区域 */
.navigation-buttons {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 20px;
}

.navigation-buttons button {
    background: #8b7355;
    color: #fff;
    border: none;
    padding: 10px;
    cursor: pointer;
    font-size: 1em;
    border-radius: 5px;
}

.navigation-buttons button:hover {
    background: #756854;
}

.page-number {
    font-size: 1.2em;
    color: #5a4a32;
    align-self: center;
    margin: 0 10px;
}

.measurer {
    position: absolute !important;
    visibility: hidden !important;
    pointer-events: none !important;
    z-index: -9999 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/readerCom.vue